<template>
  <div>
    <van-search
      v-model="childValue"
      placeholder="营员搜索"
      @search="onSearch"
    />
    <div
      v-show="List!=null"
      v-cloak
    >
      <div
        v-if="List&&List.length>0"
        style="padding:  15px  20px 60px"
      >

        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            v-for="(item,index) in List"
            :key="index"
            class="css-display"
          >
            <div style="text-align: center;font-size: 20px;font-weight: 700;padding: 0 10px;background-color:#ffffff;">
              {{item.party_title}}
            </div>

            <div class="p10-size14">
              <div class="title-s">开始日期</div>
              <div class="value-s">{{item.date_start}}</div>
            </div>
            <div class="p10-size14">
              <div class="title-s">结束日期</div>
              <div class="value-s">{{item.date_end}}</div>
            </div>
            <div class="p10-size14">
              <div class="title-s">营员姓名</div>
              <div class="value-s">{{item.real_name}}</div>
            </div>
            <div style="padding:10px 10px 0;">
              <button
                @click="skipDetail(item)"
                class="buto"
              >进入</button>
            </div>

          </div>

        </van-list>

      </div>
      <div v-show="List.length==0">
        <van-empty description="暂无信息" />
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant'
export default {
  data() {
    return {
      childValue: '',
      List: [],
    }
  },
  created() {
    this.childValue = this.$route.query.childValue
    this.onSearch()
  },
  methods: {
    onSearch() {
      this.$axios
        .post('/project/participantsearch', {
          project_id: this.project_id,
          keyword: this.childValue,
        })
        .then((res) => {
          this.List = res.data.data
        })
    },
    skipDetail(item) {
      //type 进入队伍的页面 1=> 大队长页面  2 => 中队长页面  3 =>小队长页面
      let type = item.team_type
      switch (type) {
        case 1:
          this.$router.push({
            path: '/posDetail',
            query: {
              project_id: item.project_id,
            },
          })
          break
        case 2:
          this.$router.push({
            path: '/lochus',
            query: {
              project_id: item.project_id,
              team2_id: item.team_id,
            },
          })
          break
        case 3:
          this.$router.push({
            path: '/camper',
            query: {
              project_id: item.project_id,
              team3_id: item.team_id,
            },
          })
          break
        case 0:
          Toast('暂未分配职位,无法查看队伍')
          break
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.css-display {
  background-color: #ffffff;
  color: #000000;
  border: 1px solid #f1f1f1;
  padding: 10px;
  font-size: 15px;
  border-radius: 10px;
  box-shadow: 2px 2px 4px rgba($color: #4c4d47, $alpha: 0.5);
  margin-bottom: 10px;
}
.buto {
  background-color: royalblue;
  padding: 5px 20px;
  border: none;
  border-radius: 6px;
  color: #fff;
}
.p10-size14 {
  padding: 12px 15px;
  font-size: 14px;

  .title-s {
    display: inline-block;
    width: 35%;
    font-weight: 500;
    // color: brown;
    // text-align: center;
  }

  .value-s {
    display: inline-block;
    color: #999;
    width: 65%;
    text-align: right;
  }
}
</style>